import errors from '../../../utils/errorsFactory';

export const monthList = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

const periodToPeriodNumber = (periodName, customMonthList = monthList) => {
  const index = customMonthList.findIndex(month => periodName.startsWith(month));

  if (index < 0) {
    throw errors.ValidationError('Invalid period');
  }

  return index;
};

export default periodToPeriodNumber;
